export default __webpack_public_path__ + "static/control-crypto-acea590d9052db46c657e75ab592f197.svg";